"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VViewLink_vue_1 = __importDefault(require("../scraps/VViewLink.vue"));
exports.default = vue_1.default.extend({
    name: "authorized-links",
    components: {
        VViewLink: VViewLink_vue_1.default
    }
});
